import { Image, Swiper } from "antd-mobile";
import {
  handleH5data,
  ProductDetailsTree,
} from "components/Tree/ProductDetailsTree";
import r, { api } from "modules/Request";
import DataCenterFailure from "pages/CarbonNeutralityDisclosure/Failure/DataCenterFailure";
import producttypeicon from "pages/HomePage/images/producttype.png";
import productxhicon from "pages/HomePage/images/productxh.png";
import productzlicon from "pages/HomePage/images/productzl.png";
import productzqicon from "pages/HomePage/images/productzq.png";
import { useEffect, useState } from "react";
import { businessTo } from "utils";
import CollspseStyle from "./card/CollspseStyle";
import "./index.scss";
import "./ProductDetail.scss";
export default function ProductDetail() {
  document.title = "产品详情";
  const [resAll, setResAll] = useState({});

  const [productInfo, setProductInfo] = useState(null);

  const { id, type, productType } = r.getQueryString(); // productType（1是减排基础 0是减排产品）

  const getPageList = async () => {
    let result;
    if (productType == "1") {
      result = await businessTo(r.get(`${api.GET_FILL_REVIEWBASE}${id}`));
    } else if (productType == "0") {
      result = await businessTo(
        r.get(`${api.LCA_CARBON_FOOTQRCODE_REDUCTION}${id}`)
      );
    } else {
      result = await businessTo(r.get(`${api.GET_FILL_REVIEW}${id}`));
    }
    if (!result) return;
    // setResAll(result?.zhProductDetail);
    const productInfoVal =
      result?.zhProductDetail?.getFillRecordProductInfoVo?.productInfo;
    console.log("productInfoVal", productInfoVal);
    const productInfofilter = handleH5data(
      productInfoVal?.formContext?.schema,
      productInfoVal?.formValues?.data
    );
    setResAll(result?.zhProductDetail);
    document.title = result?.zhProductDetail?.productName
      ? result?.zhProductDetail?.productName + "碳减排"
      : "碳减排";
    setProductInfo(productInfofilter);
    console.log(resAll?.cumulativeAnalyseVO);
  };

  useEffect(() => {
    r.post(api.DATA_CENTER_VISIT_H5 + id);
    getPageList();
  }, []);
  if (resAll?.h5DiscloseStatus == "0") {
    return <DataCenterFailure />;
  }
  return (
    <div className="product_detail_box">
      {/* {productInfo && <DataComponent data={productInfo} />} */}
      <div className="mini_height">
        <div className="product_detail_top_card_box">
          {/* <div className="product_detail_top_card">
            <div className="product_detail_margin">
              <p className="product_detail_top_card_title">产品信息</p>
              <p className="product_detail_top_card_msg">
                产品名称：<span>{resAll?.productName}</span>
              </p>
              <p className="product_detail_top_card_msg">
                功能单位：<span>{resAll?.featureUnit}</span>
              </p>
              <p className="product_detail_top_card_msg">
                产品重量：<span>{resAll?.productWeight}</span>
              </p>
              <p className="product_detail_top_card_msg">
                产品产量：<span>{resAll?.productValue}</span>
              </p>
              <p className="product_detail_top_card_msg">
                产品产值：<span>{resAll?.outputValue}</span>
              </p>
              <p className="product_detail_top_card_msg">
                产品型号：<span>{resAll?.productModel}</span>
              </p>
            </div>
          </div> */}
          <div className="common_card_box_no_margin">
            <div className="green_swiper_bor">
              <Swiper
                autoplay
                trackOffset={10}
                slideSize={80}
                style={{
                  "--border-radius": "8px",
                }}
                loop
                defaultIndex={0}
              >
                {resAll?.boxPicList?.map((item, index) => {
                  return (
                    <Swiper.Item key={index}>
                      <div className="swiper_box">
                        <Image height="7.13rem" fit="contain" src={item} />
                      </div>
                    </Swiper.Item>
                  );
                })}
              </Swiper>
            </div>
          </div>
          <div className="detail_box_title" style={{ fontSize: ".64rem" }}>
            {resAll?.productName || "--"}
          </div>
          <div className="white-item product-info-box">
            <div className="product-info-box-item">
              <img src={producttypeicon} alt="" />
              <div className="item-right">
                <p>产品分类</p>
                <p>{resAll?.productCategoryCodeName || "--"}</p>
              </div>
            </div>
            <div className="product-info-box-item">
              <img src={productxhicon} alt="" />
              <div className="item-right">
                <p>产品型号</p>
                <p>{resAll?.productModel || "--"}</p>
              </div>
            </div>
            <div className="product-info-box-item">
              <img src={productzqicon} alt="" />
              <div className="item-right">
                <p>生产周期</p>
                <p>
                  {resAll?.fillTime?.[0] ||
                    "-" + " - " + resAll?.fillTime?.[1] ||
                    "-"}
                </p>
              </div>
            </div>
            {resAll?.productBrief && (
              <div className="product-info-box-tip">
                <p>产品简介</p>
                <p>{resAll?.productBrief || ""}</p>
              </div>
            )}
          </div>
        </div>
        {productInfo && (
          <div className="prodetail-basic-box">
            <CollspseStyle>
              <h3 className="collspse_title">产品基础信息</h3>
              <div className="common_card_box" style={{ marginTop: 0 }}>
                <div className="product_detail_tree_box">
                  <ProductDetailsTree data={productInfo} />
                </div>
              </div>
            </CollspseStyle>
          </div>
        )}
      </div>

      {resAll?.footLogo && (
        <div className="about_box">
          <div className="data_center_logo">
            <Image src={resAll?.footLogo} />
          </div>
        </div>
      )}
    </div>
  );
}
